import { render, staticRenderFns } from "./mapAiOcr.vue?vue&type=template&id=3a5be56a&scoped=true&"
import script from "./mapAiOcr.vue?vue&type=script&lang=js&"
export * from "./mapAiOcr.vue?vue&type=script&lang=js&"
import style0 from "./mapAiOcr.vue?vue&type=style&index=0&id=3a5be56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5be56a",
  null
  
)

export default component.exports